import { Children as se, isValidElement as ie, cloneElement as ae } from "react";
var P = { exports: {} }, t = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var g;
function fe() {
  if (g) return t;
  g = 1;
  var l = Symbol.for("react.element"), c = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), u = Symbol.for("react.provider"), m = Symbol.for("react.context"), C = Symbol.for("react.server_context"), d = Symbol.for("react.forward_ref"), E = Symbol.for("react.suspense"), v = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), R = Symbol.for("react.offscreen"), _;
  _ = Symbol.for("react.module.reference");
  function a(e) {
    if (typeof e == "object" && e !== null) {
      var S = e.$$typeof;
      switch (S) {
        case l:
          switch (e = e.type, e) {
            case i:
            case o:
            case s:
            case E:
            case v:
              return e;
            default:
              switch (e = e && e.$$typeof, e) {
                case C:
                case m:
                case d:
                case y:
                case p:
                case u:
                  return e;
                default:
                  return S;
              }
          }
        case c:
          return S;
      }
    }
  }
  return t.ContextConsumer = m, t.ContextProvider = u, t.Element = l, t.ForwardRef = d, t.Fragment = i, t.Lazy = y, t.Memo = p, t.Portal = c, t.Profiler = o, t.StrictMode = s, t.Suspense = E, t.SuspenseList = v, t.isAsyncMode = function() {
    return !1;
  }, t.isConcurrentMode = function() {
    return !1;
  }, t.isContextConsumer = function(e) {
    return a(e) === m;
  }, t.isContextProvider = function(e) {
    return a(e) === u;
  }, t.isElement = function(e) {
    return typeof e == "object" && e !== null && e.$$typeof === l;
  }, t.isForwardRef = function(e) {
    return a(e) === d;
  }, t.isFragment = function(e) {
    return a(e) === i;
  }, t.isLazy = function(e) {
    return a(e) === y;
  }, t.isMemo = function(e) {
    return a(e) === p;
  }, t.isPortal = function(e) {
    return a(e) === c;
  }, t.isProfiler = function(e) {
    return a(e) === o;
  }, t.isStrictMode = function(e) {
    return a(e) === s;
  }, t.isSuspense = function(e) {
    return a(e) === E;
  }, t.isSuspenseList = function(e) {
    return a(e) === v;
  }, t.isValidElementType = function(e) {
    return typeof e == "string" || typeof e == "function" || e === i || e === o || e === s || e === E || e === v || e === R || typeof e == "object" && e !== null && (e.$$typeof === y || e.$$typeof === p || e.$$typeof === u || e.$$typeof === m || e.$$typeof === d || e.$$typeof === _ || e.getModuleId !== void 0);
  }, t.typeOf = a, t;
}
var n = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var h;
function ce() {
  return h || (h = 1, process.env.NODE_ENV !== "production" && function() {
    var l = Symbol.for("react.element"), c = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), u = Symbol.for("react.provider"), m = Symbol.for("react.context"), C = Symbol.for("react.server_context"), d = Symbol.for("react.forward_ref"), E = Symbol.for("react.suspense"), v = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), R = Symbol.for("react.offscreen"), _ = !1, a = !1, e = !1, S = !1, F = !1, M;
    M = Symbol.for("react.module.reference");
    function I(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || F || r === s || r === E || r === v || S || r === R || _ || a || e || typeof r == "object" && r !== null && (r.$$typeof === y || r.$$typeof === p || r.$$typeof === u || r.$$typeof === m || r.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === M || r.getModuleId !== void 0));
    }
    function f(r) {
      if (typeof r == "object" && r !== null) {
        var T = r.$$typeof;
        switch (T) {
          case l:
            var b = r.type;
            switch (b) {
              case i:
              case o:
              case s:
              case E:
              case v:
                return b;
              default:
                var x = b && b.$$typeof;
                switch (x) {
                  case C:
                  case m:
                  case d:
                  case y:
                  case p:
                  case u:
                    return x;
                  default:
                    return T;
                }
            }
          case c:
            return T;
        }
      }
    }
    var L = m, w = u, O = l, Y = d, N = i, D = y, z = p, V = c, q = o, j = s, U = E, W = v, $ = !1, A = !1;
    function X(r) {
      return $ || ($ = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function k(r) {
      return A || (A = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function G(r) {
      return f(r) === m;
    }
    function H(r) {
      return f(r) === u;
    }
    function Z(r) {
      return typeof r == "object" && r !== null && r.$$typeof === l;
    }
    function B(r) {
      return f(r) === d;
    }
    function J(r) {
      return f(r) === i;
    }
    function K(r) {
      return f(r) === y;
    }
    function Q(r) {
      return f(r) === p;
    }
    function ee(r) {
      return f(r) === c;
    }
    function re(r) {
      return f(r) === o;
    }
    function te(r) {
      return f(r) === s;
    }
    function ne(r) {
      return f(r) === E;
    }
    function oe(r) {
      return f(r) === v;
    }
    n.ContextConsumer = L, n.ContextProvider = w, n.Element = O, n.ForwardRef = Y, n.Fragment = N, n.Lazy = D, n.Memo = z, n.Portal = V, n.Profiler = q, n.StrictMode = j, n.Suspense = U, n.SuspenseList = W, n.isAsyncMode = X, n.isConcurrentMode = k, n.isContextConsumer = G, n.isContextProvider = H, n.isElement = Z, n.isForwardRef = B, n.isFragment = J, n.isLazy = K, n.isMemo = Q, n.isPortal = ee, n.isProfiler = re, n.isStrictMode = te, n.isSuspense = ne, n.isSuspenseList = oe, n.isValidElementType = I, n.typeOf = f;
  }()), n;
}
process.env.NODE_ENV === "production" ? P.exports = fe() : P.exports = ce();
var ue = P.exports;
function le(l, c, i) {
  return c === void 0 && (c = 0), i === void 0 && (i = []), se.toArray(l).reduce(function(s, o, u) {
    return ue.isFragment(o) ? s.push.apply(s, le(o.props.children, c + 1, i.concat(o.key || u))) : ie(o) ? s.push(ae(o, {
      key: i.concat(String(o.key)).join(".")
    })) : (typeof o == "string" || typeof o == "number") && s.push(o), s;
  }, []);
}
export {
  le as f
};
